<template>
  <div>
    <el-tabs v-model="datas.status" type="card" @tab-click="search">
      <!--  状态-->
      <el-tab-pane v-for="(item, index) in orderStatusList" :key="index" :label="item.value"
        :name="item.key + ''"></el-tab-pane>
    </el-tabs>
    <!--  搜索-->
    <div class="search">
      <!-- 开始日期-->
      <div class="item">
        <el-date-picker v-model="datas.created_at_start" :placeholder="$t('message.startDate')" class="Container"
          type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <!--  结束日期-->
      <div class="item">
        <el-date-picker v-model="datas.created_at_end" :placeholder="$t('message.dateClosed')" class="Container"
          default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <div class="item">
        <!--  搜索 -->
        <el-button type="primary" @click="search">
          {{ $t("message.search") }}
        </el-button>
        <!--  重置 -->
        <el-button @click="reset">{{ $t("message.reset") }}</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" size="medium">
        <el-table-column align="center" label="NO" prop="rowNumber" width="45">
        </el-table-column>
        <!--  订单号-->
        <el-table-column align="center" :label="$t('message.orderNumber')">
          <template slot-scope="scope">
            <p>
              <router-link :to="scope.row.status <= 30
      ? '/orderDetail?is_japanfirm=1&order_sn=' + scope.row.order_sn
      : 'orderPaymentDetail?is_japanfirm=1&order_sn=' + scope.row.order_sn
      " target="_blank" class="a-link">
                {{ scope.row.order_sn }}</router-link>
            </p>
            <p>{{ scope.row.user.realname }}</p>
          </template>
        </el-table-column>
        <!--  状态-->
        <el-table-column align="center" :label="$t('message.status')" prop="status_name" width="100">
        </el-table-column>
        <!--  订单番数-->
        <el-table-column align="center" :label="$t('message.ordersNumber')" prop="order_detail_count" width="80">
        </el-table-column>
        <!--  操作人员-->
        <el-table-column align="center" :label="$t('message.operator')">
          <template slot-scope="scope">
            <div>
              <!-- 业务员 -->
              <p>
                {{ $t("message.salesman") }}：{{ scope.row.y_admin.realname }}
              </p>
              <!-- 配货员 -->
              <p v-if="scope.row.p_admin">
                {{ $t("message.distributionMember") }}：{{ scope.row.p_admin.realname }}
              </p>
              <!-- 采购员 -->
              <p v-if="scope.row.g_admin">
                {{ $t("message.buyer") }}：{{ scope.row.g_admin.realname }}
              </p>
            </div>
          </template>
        </el-table-column>
        <!--  到货番数-->
        <!-- <el-table-column align="center" :label="$t('message.numberOfArrivals')" prop="status_name" width="80">
        </el-table-column> -->
        <!--  订单提交时间-->
        <el-table-column align="center" :label="$t('message.submitTime')" prop="created_at" width="88">
        </el-table-column>
        <!-- 翻译 -->
        <el-table-column align="center" :label="$t('message.translate')" prop="order_time_node.datetime_translate"
          width="88">
        </el-table-column>
        <!-- 确认 -->
        <el-table-column align="center" :label="$t('message.confirm')" prop="order_time_node.datetime_confirm"
          width="88">
        </el-table-column>
        <!-- 报价 -->
        <el-table-column align="center" :label="$t('message.quotedPrice')" prop="order_time_node.datetime_offer"
          width="88">
        </el-table-column>
        <!-- 客户入金 -->
        <el-table-column align="center" :label="$t('message.customersIntoGold')"
          prop="order_time_node.datetime_pay_submit" width="88">
        </el-table-column>
        <!-- 财务确认入金 -->
        <el-table-column align="center" :label="$t('message.financialConfirmation')"
          prop="order_time_node.datetime_pay_confirm" width="88">
        </el-table-column>
        <!-- 采购 -->
        <el-table-column align="center" :label="$t('message.purchase')"
          prop="order_time_node.datetime_purchase_complete" width="88">
        </el-table-column>
        <!-- 财务付款 -->
        <el-table-column align="center" :label="$t('message.financialPayment')"
          prop="order_time_node.datetime_purchase_complete" width="88">
        </el-table-column>
        <!-- 签收 -->
        <!-- prop="order_time_node.datetime_pay_submit" -->
        <el-table-column align="center" :label="$t('message.signFor')" width="88">
        </el-table-column>
        <!-- 上架 -->
        <el-table-column align="center" :label="$t('message.hitTheShelf')" prop="order_time_node.datetime_up_complete"
          width="88">
        </el-table-column>
        <!-- 出货完了 -->
        <el-table-column align="center" :label="$t('message.shippedOut')"
          prop="order_time_node.datetime_delivery_complete" width="88">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user_id: { type: Number }
  },
  data() {
    return {
      tableData: [],
      datas: {
        user_id: '',
        status: '',
        created_at_start: '',
        created_at_end: '',
        page: 1,
        pageSize: 50
      },
      total: 0
    };
  },
  computed: {
    orderStatusList() {
      let arr = [{ key: '', value: "全部" }]
      if (this.$store.state.orderStatusList instanceof Array) {
        arr = [...arr, ...this.$store.state.orderStatusList]
      }
      return arr
    },
  },
  created() {
    // this.orderList()
  },
  methods: {
    // 订单列表
    orderList() {
      this.datas.user_id = this.user_id
      this.tableData = []
      this.$api.JapaneseOffice.orderList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(res);
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.orderList();
    },
    // 重置
    reset() {
      this.datas = {
        user_id: '',
        status: '',
        created_at_start: '',
        created_at_end: '',
        page: 1,
        pageSize: 50
      }
      this.datas.page = 1
      this.orderList();
    }
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  margin-top: 12px;

  .item {
    margin-right: 24px;
  }
}

.table {
  margin: 24px 0;

  /deep/.el-table__cell .cell {
    padding: 0 5px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}
</style>